export default __webpack_public_path__ + "MAt_guideDISC.html";